import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${API_BASE}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('equimarket_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('equimarket_token');
      localStorage.removeItem('equimarket_user');
      if (window.location.pathname !== '/auth') {
        window.location.href = '/auth';
      }
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  register: (data) => api.post('/auth/register', data),
	forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
	resetPassword: (token, new_password) => api.post('/auth/reset-password', { token, new_password }),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
  updateProfile: (data) => api.put('/auth/profile', data),
	verifyEmail: (token) => api.post('/auth/verify-email', { token }),
	resendVerification: () => api.post('/auth/resend-verification'),
};

export const horseAPI = {
  list: (params) => api.get('/horses', { params }),
  get: (id) => api.get(`/horses/${id}`),
  create: (data, params) => api.post('/horses', data, { params }),
  update: (id, data, params) => api.put(`/horses/${id}`, data, { params }),
  deactivate: (id) => api.put(`/horses/${id}/deactivate`),
	reactivate: (id) => api.put(`/horses/${id}/reactivate`),
  myAds: () => api.get('/my/horses'),
	myPendingAds: () => api.get('/my/pending/horses'),
	deletePending: (id) => api.delete(`/horses/pending/${id}`),
};

export const productAPI = {
  list: (params) => api.get('/products', { params }),
  get: (id) => api.get(`/products/${id}`),
	create: (data, params) => api.post('/products', data, { params }),
  update: (id, data, params) => api.put(`/products/${id}`, data, { params }),
  deactivate: (id) => api.put(`/products/${id}/deactivate`),
	reactivate: (id) => api.put(`/products/${id}/reactivate`),
  myAds: () => api.get('/my/products'),
	myPendingAds: () => api.get('/my/pending/products'),
	deletePending: (id) => api.delete(`/products/pending/${id}`),
};

export const transportAPI = {
	list: (params) => api.get('/transports', { params }),
	get: (id) => api.get(`/transports/${id}`),
	create: (data, params) => api.post('/transports', data, { params }),
	update: (id, data, params) => api.put(`/transports/${id}`, data, { params }),
	deactivate: (id) => api.put(`/transports/${id}/deactivate`),
	reactivate: (id) => api.put(`/transports/${id}/reactivate`),
	myAds: () => api.get('/my/transports'),
	myPendingAds: () => api.get('/my/pending/transports'),
	deletePending: (id) => api.delete(`/transports/pending/${id}`),
};

export const schoolAPI = {
	list: (params) => api.get('/riding-schools', { params }),
	get: (id) => api.get(`/riding-schools/${id}`),
	create: (data, params) => api.post('/riding-schools', data, { params }),
	update: (id, data, params) => api.put(`/riding-schools/${id}`, data, { params }),
	deactivate: (id) => api.put(`/riding-schools/${id}/deactivate`),
	reactivate: (id) => api.put(`/riding-schools/${id}/reactivate`),
	myAds: () => api.get('/my/riding-schools'),
	myPendingAds: () => api.get('/my/pending/riding-schools'),
	deletePending: (id) => api.delete(`/riding-schools/pending/${id}`),
};

export const stableAPI = {
	list: (params) => api.get('/stables', { params }),
	get: (id) => api.get(`/stables/${id}`),
	create: (data, params) => api.post('/stables', data, { params }),
	update: (id, data, params) => api.put(`/stables/${id}`, data, { params }),
	deactivate: (id) => api.put(`/stables/${id}/deactivate`),
	reactivate: (id) => api.put(`/stables/${id}/reactivate`),
	myAds: () => api.get('/my/stables'),
	myPendingAds: () => api.get('/my/pending/stables'),
	deletePending: (id) => api.delete(`/stables/pending/${id}`),
};

export const trainerAPI = {
	list: (params) => api.get('/trainers', { params }),
	get: (id) => api.get(`/trainers/${id}`),
	create: (data, params) => api.post('/trainers', data, { params }),
	update: (id, data, params) => api.put(`/trainers/${id}`, data, { params }),
	deactivate: (id) => api.put(`/trainers/${id}/deactivate`),
	reactivate: (id) => api.put(`/trainers/${id}/reactivate`),
	myAds: () => api.get('/my/trainers'),
	myPendingAds: () => api.get('/my/pending/trainers'),
	deletePending: (id) => api.delete(`/trainers/pending/${id}`),
};

export const eventAPI = {
	list: (params) => api.get('/events', { params }),
	get: (id) => api.get(`/events/${id}`),
	create: (data, params) => api.post('/events', data, { params }),
	update: (id, data, params) => api.put(`/events/${id}`, data, { params }),
	deactivate: (id) => api.put(`/events/${id}/deactivate`),
	reactivate: (id) => api.put(`/events/${id}/reactivate`),
	myAds: () => api.get('/my/events'),
	myPendingAds: () => api.get('/my/pending/events'),
	deletePending: (id) => api.delete(`/events/pending/${id}`),
};

export const vetAPI = {
	list: (params) => api.get('/vets', { params }),
	get: (id) => api.get(`/vets/${id}`),
	create: (data, params) => api.post('/vets', data, { params }),
	update: (id, data, params) => api.put(`/vets/${id}`, data, { params }),
	deactivate: (id) => api.put(`/vets/${id}/deactivate`),
	reactivate: (id) => api.put(`/vets/${id}/reactivate`),
	myAds: () => api.get('/my/vets'),
	myPendingAds: () => api.get('/my/pending/vets'),
	deletePending: (id) => api.delete(`/vets/pending/${id}`),
};

export const mediaAPI = {
  upload: (formData) => api.post('/upload/image', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  uploadVideo: (formData) => api.post('/upload/video', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
	uploadCover: (formData) => api.post('/upload/cover', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
};

export const sellerAPI = {
	list: (params = {}) => api.get('/sellers', { params }),
	get: (slug) => api.get(`/sellers/${slug}`),
	horses: (slug, params = {}) => api.get(`/sellers/${slug}/horses`, { params }),
	products: (slug, params = {}) => api.get(`/sellers/${slug}/products`, { params }),
	transports: (slug, params = {}) => api.get(`/sellers/${slug}/transports`, { params }),
	schools: (slug, params = {}) => api.get(`/sellers/${slug}/riding-schools`, { params }),
	stables: (slug, params = {}) => api.get(`/sellers/${slug}/stables`, { params }),
	trainers: (slug, params = {}) => api.get(`/sellers/${slug}/trainers`, { params }),
	events: (slug, params = {}) => api.get(`/sellers/${slug}/events`, { params }),
	vets: (slug, params = {}) => api.get(`/sellers/${slug}/vets`, { params }),
};

export const favoriteAPI = {
  list: () => api.get('/favorites'),
  add: (adId, adType) => api.post(`/favorites?ad_id=${adId}&ad_type=${adType}`),
  remove: (adId) => api.delete(`/favorites?ad_id=${adId}`),
  check: (adId) => api.get(`/favorites/check?ad_id=${adId}`),
};

export const savedSearchAPI = {
	list: () => api.get('/saved-searches'),
	create: (data) => api.post('/saved-searches', data),
	update: (id, data) => api.patch(`/saved-searches/${id}`, data),
	remove: (id) => api.delete(`/saved-searches/${id}`),
};

export const reportAPI = {
	create: (data) => api.post('/reports', data),
	listAdmin: (params = {}) => api.get('/reports/admin', { params }),
	stats: () => api.get('/reports/admin/stats'),
	resolve: (id, data) => api.patch(`/reports/admin/${id}`, data),
	action: (id) => api.post(`/reports/admin/${id}/action`),
};

export const faqAPI = {
	listPublic: (lang) => api.get('/faqs', { params: { lang } }),
	listAdmin: () => api.get('/faqs/admin'),
	create: (data) => api.post('/faqs/admin', data),
	update: (id, data) => api.patch(`/faqs/admin/${id}`, data),
	remove: (id) => api.delete(`/faqs/admin/${id}`),
	seed: () => api.post('/faqs/admin/seed'),
	submitFeedback: (faqId, data) => api.post(`/faqs/${faqId}/feedback`, data),
	adminFeedback: (params = {}) => api.get('/faqs/admin/feedback', { params }),
};

export const suggestionAPI = {
	submit: (data) => api.post('/suggestions', data),
	listAdmin: (params = {}) => api.get('/suggestions/admin', { params }),
	update: (id, data) => api.patch(`/suggestions/admin/${id}`, data),
	remove: (id) => api.delete(`/suggestions/admin/${id}`),
};

export const legalAPI = {
	get: (slug, lang) => api.get(`/legal/${slug}`, { params: { lang } }),
	listAdmin: () => api.get('/legal/admin/all'),
	update: (slug, data) => api.patch(`/legal/admin/${slug}`, data),
	seed: (replace = false) => api.post('/legal/admin/seed', null, { params: { replace } }),
	consentStatus: () => api.get('/legal/consent/status'),
	consentAccept: () => api.post('/legal/consent/accept'),
	audit: (params = {}) => api.get('/legal/admin/audit', { params }),
};

export const inboxAPI = {
	list: (params = {}) => api.get('/inbox/admin', { params }),
	get: (id) => api.get(`/inbox/admin/${id}`),
	update: (id, data) => api.patch(`/inbox/admin/${id}`, data),
	remove: (id) => api.delete(`/inbox/admin/${id}`),
	webhookConfig: () => api.get('/inbox/admin/_config/webhook'),
	injectTest: (data) => api.post('/inbox/admin/_test', data),
	downloadAttachment: (id, index) =>
		api.get(`/inbox/admin/${id}/attachments/${index}/download`, { responseType: 'blob' }),
};

export const messageAPI = {
  conversations: () => api.get('/messages/conversations'),
  getMessages: (convId) => api.get(`/messages/${convId}`),
  send: (data) => api.post('/messages', data),
};

export const notificationAPI = {
  list: () => api.get('/notifications'),
  unreadCount: () => api.get('/notifications/unread-count'),
  markRead: (ids) => api.put('/notifications/read', { notification_ids: ids }),
};

export const paymentAPI = {
  checkout: (data) => api.post('/payments/checkout', data),
  status: (sessionId) => api.get(`/payments/status/${sessionId}`),
	complete: (adId) => api.put(`/payments/complete/${adId}`),
};

export const invoiceAPI = {
  list: () => api.get('/invoices'),
  downloadPdf: (id) => api.get(`/invoices/${id}/pdf`, { responseType: 'blob' }),
};

export const verificationAPI = {
  request: (data) => api.post('/verification/request', data),
	update: (id, data) => api.put(`/verification/update/${id}`, data),
  status: () => api.get('/verification/status'),
  uploadDocument: (formData) => api.post('/verification/upload-document', formData,
		{ headers: { 'Content-Type': 'multipart/form-data' } }),
	deleteDocument: (docId) => api.delete(`/verification/document/${docId}`),
	// Fetch a document as a blob (using axios so the auth token is attached)
	// and open it in a new tab. Falls back to download if popup blocked.
	viewDocument: async (docUrl, filename = 'document') => {
		// docUrl may be absolute (/api/verification/...) or relative — normalise to path after /api
		const path = docUrl.replace(/^.*\/api/, '');
		const res = await api.get(path, { responseType: 'blob' });
		const blob = new Blob([res.data], { type: res.headers['content-type'] || 'application/octet-stream' });
		const objectUrl = URL.createObjectURL(blob);
		const win = window.open(objectUrl, '_blank');
		if (!win) {
			// Popup blocked — trigger download instead
			const a = document.createElement('a');
			a.href = objectUrl;
			a.download = filename;
			document.body.appendChild(a);
			a.click();
			a.remove();
		}
		setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
	},
};

export const adminAPI = {
  stats: () => api.get('/admin/stats'),
  users: (params) => api.get('/admin/users', { params }),
  updateUser: (id, data) => api.put(`/admin/users/${id}`, data),
  ads: (params) => api.get('/admin/ads', { params }),
	pendingAds: (params) => api.get('/admin/pending/ads', { params }),
  deactivateAd: (id, type) => api.put(`/admin/ads/${id}?ad_type=${type}`),
  reactivateAd: (id, type) => api.put(`/admin/ads/${id}/reactivate?ad_type=${type}`),
	deleteHorseAd: (id) => api.delete(`/horses/${id}`),
	deleteProductAd: (id) => api.delete(`/products/${id}`),
	deleteTransportAd: (id) => api.delete(`/transports/${id}`),
	deleteSchoolAd: (id) => api.delete(`/riding-schools/${id}`),
	deleteStableAd: (id) => api.delete(`/stables/${id}`),
	deleteTrainerAd: (id) => api.delete(`/trainers/${id}`),
	deleteEventAd: (id) => api.delete(`/events/${id}`),
	deleteVetAd: (id) => api.delete(`/vets/${id}`),
  breeds: () => api.get('/breeds'),
  createBreed: (data) => api.post('/admin/breeds', data),
  updateBreed: (id, data) => api.put(`/admin/breeds/${id}`, data),
  deleteBreed: (id) => api.delete(`/admin/breeds/${id}`),
	coats: () => api.get('/coats'),
	createCoat: (data) => api.post('/admin/coats', data),
	updateCoat: (id, data) => api.put(`/admin/coats/${id}`, data),
	deleteCoat: (id) => api.delete(`/admin/coats/${id}`),
  categories: () => api.get('/categories'),
  createCategory: (data) => api.post('/admin/categories', data),
  updateCategory: (id, data) => api.put(`/admin/categories/${id}`, data),
  deleteCategory: (id) => api.delete(`/admin/categories/${id}`),
  verifications: (status) => api.get('/verification/admin/requests', { params: { status } }),
  reviewVerification: (id, data) => api.put(`/verification/admin/review/${id}`, data),
  getSettings: () => api.get('/admin/settings'),
  updateSettings: (data) => api.put('/admin/settings', data),
  revenue: () => api.get('/admin/revenue'),
  adsDistribution: () => api.get('/admin/ads-distribution'),
	promoteToFeatured: (id, type) => api.put(`/admin/featured/${id}?ad_type=${type}`),
	makeAdStandard: (id, type) => api.put(`/admin/standard/${id}?ad_type=${type}`),
};

export const gdprAPI = {
  exportData: () => api.get('/gdpr/export'),
  exportFull: () => api.get('/gdpr/export-full'),
  deleteAccount: () => api.delete('/gdpr/delete-account'),
  anonymize: () => api.post('/gdpr/anonymize'),
};

export const breedsAPI = {
  list: () => api.get('/breeds'),
};

export const coatsAPI = {
	list: () => api.get('/coats'),
};

export const categoriesAPI = {
  list: () => api.get('/categories'),
};

export const publicAPI = {
  settings: () => api.get('/public/settings'),
};

export const searchAPI = {
  unified: (params) => api.get('/search', { params }),
};

// WebSocket helper
export function createMessageWS(token) {
  const wsBase = API_BASE.replace(/^http/, 'ws');
  return new WebSocket(`${wsBase}/api/ws/${token}`);
}

export const onlineAPI = {
  list: () => api.get('/users/online'),
};

export const ratingAPI = {
	create: (data) => api.post('/ratings', data),
	update: (id, data) => api.put(`/ratings/${id}`, data),
	remove: (id) => api.delete(`/ratings/${id}`),
	listForSeller: (sellerId, params = {}) => api.get(`/ratings/seller/${sellerId}`, { params }),
	summary: (sellerId) => api.get(`/ratings/seller/${sellerId}/summary`),
	batchSummary: (sellerIds) => api.post('/ratings/summary', { seller_ids: sellerIds }),
	my: (sellerId) => api.get('/ratings/my', { params: { seller_id: sellerId } }),
	report: (id, data) => api.post(`/ratings/${id}/report`, data),
	// Admin
	adminReports: (params = {}) => api.get('/ratings/admin/reports', { params }),
	adminStats: () => api.get('/ratings/admin/stats'),
	adminResolveReport: (id, data) => api.patch(`/ratings/admin/reports/${id}`, data),
	adminRemoveRating: (id, reason) => api.delete(`/ratings/admin/${id}`, { params: { reason } }),
};

export default api;
